/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	QualificationEnum,
	QualificationEnumFromJSON,
	QualificationEnumFromJSONTyped,
	QualificationEnumToJSON,
} from "./QualificationEnum";

/**
 *
 * @export
 * @interface EvaluationDTO
 */
export interface EvaluationDTO {
	/**
	 *
	 * @type {string}
	 * @memberof EvaluationDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof EvaluationDTO
	 */
	academicUserId?: string;
	/**
	 *
	 * @type {number}
	 * @memberof EvaluationDTO
	 */
	selfEvaluationScore1?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EvaluationDTO
	 */
	selfEvaluationScore2?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EvaluationDTO
	 */
	peerEvaluationScore?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EvaluationDTO
	 */
	studentEvaluationScore?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EvaluationDTO
	 */
	year?: number;
	/**
	 *
	 * @type {QualificationEnum}
	 * @memberof EvaluationDTO
	 */
	departmentDirectorQualification?: QualificationEnum;
}

export function EvaluationDTOFromJSON(json: any): EvaluationDTO {
	return EvaluationDTOFromJSONTyped(json, false);
}

export function EvaluationDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EvaluationDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		academicUserId: !exists(json, "academicUserId")
			? undefined
			: json["academicUserId"],
		selfEvaluationScore1: !exists(json, "selfEvaluationScore1")
			? undefined
			: json["selfEvaluationScore1"],
		selfEvaluationScore2: !exists(json, "selfEvaluationScore2")
			? undefined
			: json["selfEvaluationScore2"],
		peerEvaluationScore: !exists(json, "peerEvaluationScore")
			? undefined
			: json["peerEvaluationScore"],
		studentEvaluationScore: !exists(json, "studentEvaluationScore")
			? undefined
			: json["studentEvaluationScore"],
		year: !exists(json, "year") ? undefined : json["year"],
		departmentDirectorQualification: !exists(
			json,
			"departmentDirectorQualification"
		)
			? undefined
			: QualificationEnumFromJSON(json["departmentDirectorQualification"]),
	};
}

export function EvaluationDTOToJSON(value?: EvaluationDTO | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		academicUserId: value.academicUserId,
		selfEvaluationScore1: value.selfEvaluationScore1,
		selfEvaluationScore2: value.selfEvaluationScore2,
		peerEvaluationScore: value.peerEvaluationScore,
		studentEvaluationScore: value.studentEvaluationScore,
		year: value.year,
		departmentDirectorQualification: QualificationEnumToJSON(
			value.departmentDirectorQualification
		),
	};
}
